module.exports = __webpack_public_path__ + "static/media/NP.69c57d63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/NP.svg
// module id = 2230
// module chunks = 7